/* eslint-disable max-len */
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router';
import useAppStore from '../../store/appStore';
import { trackPageView } from '../../tracking';

export default function HelmetWrapper() {
  const location = useLocation();
  const language = useAppStore((state) => state.appLanguage);

  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);

  const scripts = [];
  scripts.push(
    <script
      id="CookieConsent"
      key="CookieConsent"
      src="https://policy.app.cookieinformation.com/uc.js"
      data-culture={language.toUpperCase()}
    />,
  );

  const helmet = React.createElement(Helmet, null, scripts);

  return helmet;
}
